import { Keys, Scene } from "excalibur";
import { Player } from "../../player";
import { OpenHive } from "../../actors/openHive";
import { goToScene } from "../../main";
import Dialog from "../../ui/dialog";
import {
  hiveState,
  inventoryState,
  playerState,
} from "../../state/stateManager";
import {
  createGainedItem,
  getRandomBetween,
  sendAlert,
  startStingTimer,
} from "../../utils";
import { Resources } from "../../Resources";

export default class Mite extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;
    this.showingTreatmentsMenu = false;
    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 2;
    this.showingMiteCount = false;
    this.playerAnim = false;
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }

  onActivate(data) {
    console.log("data from activation: ", data);
    this.inventory = inventoryState.getInventory();
    this.treatmentsAvailable = this.inventory.treatments;
    this.hiveStats = data.data;
    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);

    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.miteMenu = document.getElementById("mite-menu");
    console.log("miteMenu: ", this.miteMenu);
    this.miteMenu.style.display = "block";
    this.miteMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
        
        ${showMiteMenu(0)}
        `;
    if (this.hiveStats.alive) {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "menu",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.stopTimer();
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onDeactivate() {
    this.stingTimer && this.stingTimer.stop();
    this.selected = null;
    this.activeItem = 0;
    this.hive.kill();
  }
  onPreUpdate() {
    if (!this.playerAnim) {
      if (!this.showingTreatmentsMenu) {
        this.player.doAnim("holdingMiteJar");
      } else {
        this.player.doAnim("leftIdleBobble");
      }
    } else {
      this.player.doAnim("shakeMites");
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();

      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (!this.showingMiteCount && !this.showingTreatmentsMenu) {
        switch (this.activeItem) {
          case 0:
            this.setPlayerAnim(true);
            Resources.Liquid.play();
            this.showingMiteCount = true;
            let miteCount = getMiteCount(this.hiveStats);
            let content = "I counted " + miteCount + " mites.";
            this.miteDisplay = new Dialog([content], () => {}, "player");
            break;
          case 1:
            console.log("MITE: pressed enter, should show treatments menu");
            this.menuItems = 3;
            this.showingTreatmentsMenu = true;
            this.miteMenu.innerHTML = `<h1>Hive: ${
              this.hiveStats.id
            }</h1> ${showTreatmentsMenu(
              this.activeItem,
              this.treatmentsAvailable
            )}`;
            break;
          default:
            break;
        }
      } else if (this.showingTreatmentsMenu) {
        switch (this.activeItem) {
          case 0:
            if (this.treatmentsAvailable.acidVapors > 1) {
              //apply acid vapor

              applyTreatment(this.hiveStats, "acidVapor");
              this.inventory.treatments.acidVapors =
                this.inventory.treatments.acidVapors - 1;
              inventoryState.setInventory(this.inventory);
            } else {
              sendAlert("You Do Not Have Acid Vapor In Inventory");
            }
            break;
          case 1:
            if (this.treatmentsAvailable.acidPads > 1) {
              //apply acid pad
              applyTreatment(this.hiveStats, "acidPad");
              this.inventory.treatments.acidPads =
                this.inventory.treatments.acidPads - 1;
              inventoryState.setInventory(this.inventory);
            } else {
              sendAlert("You Do Not Have Acid Pad In Inventory");
            }
            break;
          case 2:
            if (this.treatmentsAvailable.synthetic > 1) {
              //apply synthetic
              applyTreatment(this.hiveStats, "synthetic");
              this.inventory.treatments.synthetic =
                this.inventory.treatments.synthetic - 1;
              inventoryState.setInventory(this.inventory);
            } else {
              sendAlert("You Do Not Have Synthetic Pad In Inventory");
            }
            break;
          default:
            break;
        }
      } else {
        this.showingMiteCount = false;
        this.miteDisplay.enterPress();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.showingMiteCount) {
        this.showingMiteCount = false;
        this.miteDisplay.enterPress();
      } else if (this.showingTreatmentsMenu) {
        this.showingTreatmentsMenu = false;
        this.activeItem = 0;
        this.miteMenu.innerHTML = `<h1>Hive: ${
          this.hiveStats.id
        }</h1>${showMiteMenu(this.activeItem)}`;
      } else {
        console.log("pressed x should go back");
        //go back
        this.miteMenu.style.display = "none";
        this.menuContainer.style.display = "none";
        this.selected = null;
        this.activeItem = 0;
        goToScene("hiveMenu", this.hiveStats);
      }
    }
    if (!this.showingTreatmentsMenu) {
      this.miteMenu.innerHTML = `<h1>Hive: ${
        this.hiveStats.id
      }</h1>${showMiteMenu(this.activeItem)}`;
    } else {
      this.miteMenu.innerHTML = `<h1>Hive: ${
        this.hiveStats.id
      }</h1> ${showTreatmentsMenu(this.activeItem, this.treatmentsAvailable)}`;
    }
  }
}
function showTreatmentsMenu(active, treatmentsAvailable) {
  let vapor, acidPad, syntheticPad;
  vapor = treatmentsAvailable.acidVapors;
  if (vapor == undefined || vapor == null) {
    vapor = 0;
  }
  acidPad = treatmentsAvailable.acidPads;
  if (acidPad == undefined || acidPad === null) {
    acidPad = 0;
  }
  syntheticPad = treatmentsAvailable.synthetic;
  if (syntheticPad == undefined || syntheticPad == null) {
    syntheticPad = 0;
  }
  if (active === 0) {
    return `<h3>Apply Treatments</h3><ul>
            <li id="list0"><span id="selector">></span> Acid Vapor (${vapor})</li>
            <li id="list1">Acid Pad (${acidPad})</li>
          <li id="list1">Synthetic Pad (${syntheticPad})</li>
          </ul>`;
  } else if (active === 1) {
    return `<h3>Apply Treatments</h3><ul>
           <li id="list0">Acid Vapor (${vapor})</li>
            <li id="list1"><span id="selector">></span> Acid Pad (${acidPad})</li>
          <li id="list1">Synthetic Pad (${syntheticPad})</li>
          
          </ul>`;
  } else if (active === 2) {
    return `<h3>Apply Treatments</h3><ul>
        <li id="list0">Acid Vapor (${vapor})</li>
         <li id="list1">Acid Pad (${acidPad})</li>
       <li id="list1"><span id="selector">></span> Synthetic Pad (${syntheticPad})</li>
       
       </ul>`;
  }
}
function showMiteMenu(active) {
  if (active === 0) {
    return `<h3>Manage Mites</h3><ul>
          <li id="list0"><span id="selector">></span> Mite Wash/Count</li>
          <li id="list1">Treatments</li>
        
        </ul>`;
  } else {
    return `<h3>Manage Mites</h3><ul>
          <li id="list0">Mite Wash/Count</li>
          <li id="list1"><span id="selector">></span>Treatments</li>
        
        </ul>`;
  }
}

function getMiteCount(hiveStats) {
  let miteCount = Math.ceil(
    (hiveStats.miteCount / hiveStats.beeFrames.count) * 2
  );

  return miteCount;
}

function applyTreatment(hive, treatment) {
  let hives = hiveState.getHives();
  let hivesObj = JSON.parse(JSON.stringify(hives));
  const acidPadEfficacy = getRandomBetween(0.6, 0.95);
  const acidVaporEfficacy = getRandomBetween(0.15, 0.5);
  const syntheticEfficacy = getRandomBetween(0.8, 0.99);
  const acidPadDamage = 1;
  const acidVaporDamage = 0;
  const syntheticDamage = 3;
  let efficacy, damage;
  let newHives = [];

  hivesObj.forEach((hiveObj, i) => {
    if (hiveObj.birth == hive.birth) {
      console.log("treatment: got hive: ", hiveObj);
      switch (treatment) {
        case "acidPad":
          efficacy = acidPadEfficacy;
          damage = acidPadDamage;
          break;
        case "acidVapor":
          efficacy = acidVaporEfficacy;
          damage = acidVaporDamage;
          break;
        case "synthetic":
          efficacy = syntheticEfficacy;
          damage = syntheticDamage;
          break;
        default:
          break;
      }
      console.log("treatment: mitecount before ", hiveObj.miteCount);
      console.log("treatment: efficacy ", efficacy);
      let newMiteCount =
        parseFloat(hiveObj.miteCount) * (1 - parseFloat(efficacy));
      hiveObj.miteCount = newMiteCount;
      console.log("treatment: mitecount after ", newMiteCount);
      hiveObj.beeFrames.count = hiveObj.beeFrames.count - damage;
      for (i = 0; i < damage; i++) {
        hiveObj.beeFrames.frames.splice(hiveObj.beeFrames.length - 1, 1);
      }
      newHives.push(hiveObj);
    } else {
      newHives.push(hiveObj);
    }
  });
  createGainedItem("Treated with " + treatment);
  Resources.Feed.play();
  hiveState.setHives(newHives);
}
